<template>
    <div id="app">
        <div class="mala-content clearfix">
            <!-- 头部导航 -->
            <Topmenu v-if="$route.meta.topMenu"></Topmenu>
            <!-- 左侧导航 -->
            <Myleft v-show="$route.meta.leftShow" ref="leftMenu"></Myleft>
            <div class="right-div" :class="{detailbody:!$route.meta.leftShow}">
                <router-view></router-view>  
            </div>
        </div>
        <!-- 提示弹框 -->
        <Dialog ref="tipsModal" type="alert">
            <div slot="mdBox">
                <p class="ac" v-html="tipsHtml"></p>
            </div>
        </Dialog>
        <!-- loading -->
        <div class="loadBox ac" v-show="showLoad">
            <div class="loadCont">
                <img src="/static/images/loading1.gif"/>
                <p>{{loadHtml}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Dialog from '@/components/dialog'
import Myleft from '@/components/left'
import Topmenu from '@/components/topMenu'
export default {
  components: {Myleft,Topmenu,Dialog},
  name: 'App',
  data(){
        return{
            projectType:0,//项目类型 0是清博管家 1是颜如玉
            logos:['/static/images/logo.png','/static/images/logo/y_logo.png'],
            vipInfo:[],//页面权限
            notice:[],//公告
            isSignin:false,//判断是否登录
            realmName:'',//页面域名
            vipCollocation:[
                {'name':'免费会员','icon':'','className':'member-bgcl1'},
                {'name':'V1会员','icon':'icons grade-icon1','className':'member-bgcl2'},
                {'name':'V2会员','icon':'icons grade-icon2','className':'member-bgcl3'},
                {'name':'V3会员','icon':'icons grade-icon3','className':'member-bgcl4'},
                {'name':'机构版会员','icon':'icons grade-icon4','className':'member-bgcl5'}
            ],
            bigUrl:'http://newguanjia.gsdata.cn',
            levels:[1,2,3,4,20],
            tipsHtml:'',
            showLoad:'',
            loadHtml:'正在加载...',
			userLevel:'',
			mediaId:'',//媒体id
			wbmediaId:'',//媒体id
			ttmediaId:'',//媒体id
			currentPage:'',//用户列表分页
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            // 验证登录信息
            let host = window.location.host;
            if(host === 'newguanjia.gsdata.cn' || host === 'gj.gsdata.cn'){//线上
                that.realmName = 'http://' + host + '/';
                let cooke = document.cookie.indexOf("_gsdataCL=");
                if(cooke != -1){
                    that.isSignin = true;
                    that.getPower();
                }else{
                    if(that.$route.meta.requireAuth){
                        window.location.href="https://u2.gsdata.cn/member/login?url="+that.realmName+"";
                    }
                }
            }else{//本地
                that.isSignin = true;
                that.getPower();
            }
        })
    },
    created() {
        
    },
    methods:{
        // 获取权限接口
        getPower () {
            let that = this;
            that.$api.post('personal/member', null, r => {
                that.returnCode(r,function(){
                    that.vipInfo = r.data.user;
                    that.notice = r.data.msg;
					that.userLevel = r.data.user.level;
                    if(that.$route.meta.levelPower === 2 && r.data.user.level != 20){//个人用户
                        that.$router.push({path:'/accountList'})
                    }else if(that.$route.meta.vip && r.data.user.userType === 2){//机构普通
                        that.$router.push({path:'/'})
                    }
                    that.$refs.leftMenu.powerFilter();
                })
            })
        },
        loadModal(isShow,txt){
            let that = this;
            if(txt!=''){
                that.loadHtml = txt;
            }
            that.showLoad = isShow;
        },
        // alert提示
        alertTips (text) {
            this.tipsHtml = text;
            this.$refs.tipsModal.showMaskFun();
        },
        // code判断
        returnCode (data,callback) {
            let code = data.code;
            if(code === 1){
                callback();
            }
            else if(code === 8){//未登录
                window.location.href="https://u2.gsdata.cn/member/login?url="+this.realmName+"";
            }
            else if(code === 9){
                this.alertTips('您没有此权限，请<span class="color-blue">联系管理员开通</span>');
            }else{
                this.showLoad = false;
                this.$utils.alertText(data.msg);
            }
        }        
    }
}
</script>

<style>
  @import "./style/animate.css";
  @import "./style/base.css";
  @import "./style/style.css";
</style>



// WEBPACK FOOTER //
// src/App.vue